import React from 'react';
import { Redirect } from 'react-router';

import features from '~/constants/features';

import paths from '../paths';

const Sales: React.FC<void> = () => {
  if (features.sales.enabled) {
    return <Redirect to={paths.sales.table} />;
  } else {
    return <Redirect to={paths.home._} />;
  }
};

export default Sales;
